import React from 'react';

type StepIndicatorProps = {
  currentStep: number;
  steps: string[];
  onStepClick?: (stepNumber: number) => void;
  disabledSteps?: number[];
};

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, steps, onStepClick, disabledSteps }) => {
  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;
          const isDisabled = disabledSteps?.includes(stepNumber);
          return (
            <React.Fragment key={index}>
              {/* Step Circle */}
              <div 
                className="flex flex-col items-center"
                onClick={() => {
                  if (!isDisabled) {
                    onStepClick?.(stepNumber);
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <div
                  className={`flex items-center justify-center w-10 h-10 rounded-full text-white text-sm font-medium mb-2 transition-all duration-300 
                    ${isActive ? 'bg-blue-500 ring-4 ring-blue-100' : 
                      isCompleted ? 'bg-green-500' : 'bg-gray-300'}`}
                >
                  {isCompleted ? (
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  ) : (
                    stepNumber
                  )}
                </div>
                <span className={`text-sm font-medium ${isActive || isCompleted ? 'text-gray-800' : 'text-gray-500'}`}>
                  {step}
                </span>
              </div>
              
              {/* Connector Line (except after the last step) */}
              {index < steps.length - 1 && (
                <div 
                  className={`flex-1 h-1 mx-2 transition-all duration-300 
                    ${index + 1 < currentStep ? 'bg-green-500' : 'bg-gray-300'}`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;